import { sendJsonRequest, retrieveJsonRequest } from "./utils";

export function create(post_site_id, post_id, site_id) {
    const body = {
        post_site_id,
        post_id,
        site_id,
    };

    return sendJsonRequest("/core/feeds/post/likes/", "POST", body);
}

export function remove(post_site_id, post_id) {
    const body = {
        post_id,
        post_site_id,
    };

    return sendJsonRequest("/core/feeds/post/likes/", "DELETE", body);
}

export function list(post_id) {
    return retrieveJsonRequest(`/core/feeds/post/likes/${post_id}`);
}
